/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StrategyBackground = {
    InterimExecutive: 'INTERIM_EXECUTIVE',
    ManagementConsultant: 'MANAGEMENT_CONSULTANT'
} as const;
export type StrategyBackground = typeof StrategyBackground[keyof typeof StrategyBackground];


export function instanceOfStrategyBackground(value: any): boolean {
    for (const key in StrategyBackground) {
        if (Object.prototype.hasOwnProperty.call(StrategyBackground, key)) {
            // @ts-ignore
            if (StrategyBackground[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StrategyBackgroundFromJSON(json: any): StrategyBackground {
    return StrategyBackgroundFromJSONTyped(json, false);
}

export function StrategyBackgroundFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategyBackground {
    return json as StrategyBackground;
}

export function StrategyBackgroundToJSON(value?: StrategyBackground | null): any {
    return value as any;
}

